import { render, staticRenderFns } from "./CetakKartu.vue?vue&type=template&id=6949bbde&"
import script from "./CetakKartu.vue?vue&type=script&lang=js&"
export * from "./CetakKartu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports